import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import frCore from './locales/fr/core.json';
import frAuth from './locales/fr/auth.json';
import frLanding from './locales/fr/landing.json';
import frLegal from './locales/fr/legal.json';
import frStudy from './locales/fr/study.json';
import frDashboard from './locales/fr/dashboard.json';
import frAccount from './locales/fr/account.json';
import frAdmin from './locales/fr/admin.json';
import frComponents from './locales/fr/components.json';

import enCore from './locales/en/core.json';
import enAuth from './locales/en/auth.json';
import enLanding from './locales/en/landing.json';
import enLegal from './locales/en/legal.json';
import enStudy from './locales/en/study.json';
import enDashboard from './locales/en/dashboard.json';
import enAccount from './locales/en/account.json';
import enAdmin from './locales/en/admin.json';
import enComponents from './locales/en/components.json';

export const SUPPORTED_LANGUAGES = ['fr', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'fr';

const LANG_STORAGE_KEY = 'cloudmaster.lang';

const fr = {
  ...frCore,
  ...frAuth,
  ...frLanding,
  ...frLegal,
  ...frStudy,
  ...frDashboard,
  ...frAccount,
  ...frAdmin,
  ...frComponents,
};

const en = {
  ...enCore,
  ...enAuth,
  ...enLanding,
  ...enLegal,
  ...enStudy,
  ...enDashboard,
  ...enAccount,
  ...enAdmin,
  ...enComponents,
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: LANG_STORAGE_KEY,
      caches: ['localStorage'],
    },
    returnNull: false,
  });

if (typeof window !== 'undefined') {
  const stored = window.localStorage.getItem(LANG_STORAGE_KEY);
  if (!stored) {
    window.localStorage.setItem(LANG_STORAGE_KEY, DEFAULT_LANGUAGE);
    void i18n.changeLanguage(DEFAULT_LANGUAGE);
  }
}

export default i18n;
